import { getVotingPeriods, GetVotingPeriodsParams } from 'utils/apiService/PinkSale';
import queryKey from 'configs/queryKey';
import { useQuery } from '@tanstack/react-query';

function useVotingPeriods({ page, limit }: GetVotingPeriodsParams) {
  return useQuery(
    [queryKey.PINK_SALE_VOTING_PERIOD, page, limit],
    () => getVotingPeriods({ page, limit }),
    {
      enabled: Boolean(page) && Boolean(limit),
      staleTime: 60 * 1000,
    }
  );
}

export default useVotingPeriods;

